// upsell js start

window.initUpsellSlider = function () {
  const upsellSlider = document.querySelector('.cart-upsells-slider .flickity-wrapper');
  if (upsellSlider) {
    if (upsellSlider.flickityInstance) {
      upsellSlider.flickityInstance.destroy();
    }
    const flickity = new Flickity(upsellSlider, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: false,
      groupCells: 1,
      prevNextButtons: true
    });

    upsellSlider.flickityInstance = flickity;
  }
};


function cartHtml(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'CartDrawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const destination = document.querySelector('.cart-drawer');
    const source = html.getElementById(cartid);			 
    if (source && destination) destination.innerHTML = source.innerHTML;
    window.initUpsellSlider();
    window.initUpsellFormListeners();
  });
}

function cartBubbleHtml(){
  fetch(window.Shopify.routes.root +'?section_id=cart-icon-bubble')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'shopify-section-cart-icon-bubble';
    const html = new DOMParser().parseFromString(responseText, 'text/html')
    const destination = document.querySelector('.header__icon--cart');
    const source = html.getElementById(cartid);			 
    if (source && destination) destination.innerHTML = source.innerHTML;
  });
}

window.initUpsellFormListeners = function () {
  document.querySelectorAll('.upsell-form').forEach((form) => {
    // Remove previous listener if any to prevent duplicate submits
    form.removeEventListener('submit', form._submitHandler);

    const submitHandler = function (e) {
      e.preventDefault();

      const formData = new FormData(form);
      
      const data = {
        id: formData.get('id'),
        quantity: 1
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(res => res.json())
        .then(() => {
          cartHtml(); // assuming this updates and re-renders the cart drawer
          cartBubbleHtml();
        })
        .catch(err => {
          console.error('Add to cart error:', err);
        });
    };

    // Attach handler and store reference for future removal
    form.addEventListener('submit', submitHandler);
    form._submitHandler = submitHandler;
  });

  document.querySelectorAll('.upsell-form .variant-select').forEach(function (select) {
    select.addEventListener('change', function (event) {

      const selectedOption = select.options[select.selectedIndex];
      const available = selectedOption.dataset.available;

      console.log('available:: ',available);

      if(available.toLowerCase() == 'false') {
        select.closest('.upsell-form').querySelector('.atc-button').setAttribute("disabled","disabled");
      } else {
        select.closest('.upsell-form').querySelector('.atc-button').removeAttribute("disabled");
      }
      event.stopPropagation(); // Prevent other listeners (like global Shopify variant change logic)
      // Optionally: handle size change inside upsell manually here
    });
  });

  let cartUpsellWrapper = document.querySelector(".cart-upsells-slider-wrapper");
  if(cartUpsellWrapper && cartUpsellWrapper.classList.contains("visibility__hidden")){
    cartUpsellWrapper.classList.remove("visibility__hidden");
  }
  
};
window.addEventListener('load', () => {
  window.initUpsellFormListeners();
});

// upsell js end




class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    // cartLink.addEventListener('mouseover', (event) => {
    //   event.preventDefault();
    //   this.open(cartLink);
    // });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });

    setTimeout(() => {
      window.initUpsellSlider();
      window.initUpsellFormListeners();
    },500);

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
